export const INTERIOR_DOORS_PATH = '/uslugi/gotovye-resheniya-pod-klyuch/mezhkomnatnye-dveri-na-zakaz/';

export const INTERIOR_DOORS_ELEMENT_BLOCK = 'landingMezhkomnatnyeDveri';

export const INTERIOR_DOORS_LANDING_NAME = 'interior-doors';

export const INTERIOR_DOORS_OLD_LANDING_NAME = 'room-doors';

export const INTERIOR_DOORS_SERVICE_ID = '2940';

export const INTERIOR_DOORS_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/interior-doors';

export const INTERIOR_DOORS_HEADER_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/fudzi/elbrus/images/landings/interior-doors';
